import { render, staticRenderFns } from "./PublicHome.vue?vue&type=template&id=6a85016c&scoped=true"
import script from "./PublicHome.vue?vue&type=script&lang=js"
export * from "./PublicHome.vue?vue&type=script&lang=js"
import style0 from "./PublicHome.vue?vue&type=style&index=0&id=6a85016c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a85016c",
  null
  
)

export default component.exports